<template>
  <div class="notification-text">
    <template v-if="!mini">
      <p v-if="status==='denied'">
        Powiadomienia zostały zablokowane. Należy odblokować je w opcjach przeglądarki oraz odświeżyć aplikację.
      </p>
      <p v-if="status==='granted'">
        Powiadomienia dla tej przeglądarki są włączone.
        <v-btn flat color="primary" @click="unsubscribe">Wyłącz</v-btn>
      </p>
      <p v-if="status==='unsupported'">
        Ta przeglądarka nie obsługuje powiadomień.
      </p>
      <p v-if="status==='ready'">
        Aby otrzymywać powiadomienia push bezpośrednio do przeglądarki
        <v-btn flat color="primary" @click="subscribe">Włącz powiadomienia</v-btn>
      </p>
    </template>
    <p v-if="mini && status==='ready'">
      <v-btn flat color="primary" @click="subscribe">Włącz powiadomienia</v-btn>
    </p>
  </div>
</template>

<script>
import * as push from '@/utils/push.js'
export default {
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      status: ''
    }
  },
  created () {
    this.getStatus()
  },
  methods: {
    getStatus () {
      if (push.compatibleBrowser()) {
        if (Notification.permission === 'denied') {
          this.status = 'denied'
        } else {
          navigator.serviceWorker.ready.then((swRegistration) => {
            swRegistration.pushManager.getSubscription()
              .then((subscription) => {
                let isSubscribed = !(subscription === null)
                if (isSubscribed) {
                  this.status = 'granted'
                } else {
                  this.status = 'ready'
                }
              })
          })
        }
      } else {
        this.status = 'unsupported'
      }
    },
    subscribe () {
      push.subscribeUser().then(() => {
        this.status = 'granted'
      }).catch(() => {
        this.status = 'denied'
      })
    },
    unsubscribe () {
      push.unsubscribe().then(() => {
        this.status = 'ready'
      })
    }
  }
}
</script>
<style>
.notification-text {
  font-size: 16px;
  color: rgba(0,0,0,0.54);
}
</style>



// WEBPACK FOOTER //
// src/notifications/NotificationsPushInit.vue